<template>
  <div>
        <template v-if="perfil == 0">
            <Inicio></Inicio>
        </template>
         <template v-else>
             <Inicio2 :perfil="perfil"></Inicio2>   
        </template>
  </div>
</template>

<script>
import Inicio from './Inicio.vue'; 
import Inicio2 from './Inicio2.vue'; 
export default {
  name: 'Login', 
  components: { 
    Inicio,
    Inicio2 
  },
  data(){
    return{
      isMobile: this.$mobile(),
      perfil:0,
    }
  },
  created() {
     this.$bus.$on("cambia_login", (data) => { 
        this.perfil = data;
      });

     this.$bus.$on("regresa_login",
      () => {
         this.perfil = 0;
      });
  },
}
</script>

<style>

</style>